import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './services/i18n';
import { initFirebaseAnalytics } from './utils/firebaseAnalytics';
import { initAnalytics } from './utils/analytics';

// Initialize Analytics
initFirebaseAnalytics();
initAnalytics();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
